import type { NewShippingRate, ShippingAddress, ShippingZones } from '~/services/api.server';

export function getShippingRates(addresses: Array<{ weight: number } & ShippingAddress>) {
  const zones = JSON.parse(
    localStorage.getItem('shipping-zones') || '{ "us_zones": [], "international_zones": [] }'
  ) as ShippingZones;

  const rates: Array<NewShippingRate | undefined> = [];

  for (const recipient of addresses) {
    const { weight, country, postal_code } = recipient;

    const rate =
      country === 'US'
        ? getRateByZip(postal_code, weight, zones.us_zones)
        : getRateByCountry(country, weight, zones.international_zones);

    rates.push(rate);
  }
  return rates;
}

function getRateByCountry(country: string, weight: number, zones: ShippingZones['international_zones']) {
  const zone = zones.find((z) => z.iso2 === country);
  if (!zone) return undefined;

  const zoneRates = JSON.parse(localStorage.getItem('international-rate-' + zone.zone) ?? '[]') as NewShippingRate[];
  return getRateByWeight(weight, zoneRates);
}

function getRateByZip(zip: string, weight: number, zones: ShippingZones['us_zones']) {
  const zone = zones.find((z) => +z.zip_code_start <= +zip && +z.zip_code_end >= +zip);
  if (!zone) return undefined;

  const zoneStandardRates = JSON.parse(
    localStorage.getItem('us-rate-' + zone.zone_standard) ?? '[]'
  ) as NewShippingRate[];

  const same = zone.zone_standard === zone.zone_express;
  if (same) {
    return getRateByWeight(weight, zoneStandardRates);
  }

  const zoneExpressRates = JSON.parse(
    localStorage.getItem('us-rate-' + zone.zone_express) ?? '[]'
  ) as NewShippingRate[];

  const standardRate = getRateByWeight(weight, zoneStandardRates);
  const expressRate = getRateByWeight(weight, zoneExpressRates);

  return {
    id: Math.floor(Math.random() * -10000),
    zone: [standardRate?.zone, expressRate?.zone].join('-'),
    weight,
    standard: standardRate?.standard ?? null,
    express: expressRate?.express ?? null,
  };
}

function getRateByWeight(weight: number, rates: NewShippingRate[]) {
  const maximumWeight = rates.at(-1)?.weight ?? Infinity;
  if (weight >= maximumWeight) {
    return rates.at(-1);
  }

  const rate = rates.find((r) => r.weight === weight);
  return rate;
}

export function getWeightInPounds(weight: number, unit: string) {
  switch (unit) {
    case 'mg':
      return weight / 453592.37;
    case 'g':
      return weight / 453.59237;
    case 'gr':
      return weight / 453.59237;
    case 'kg':
      return weight * 2.20462;
    case 'oz':
      return weight / 16;
    default:
      return weight;
  }
}
